// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1zbnn","label":"styles_label__2iVNf"};